export default "__VITE_ASSET__CP$kw5Rs__"